import { NgModule } from '@angular/core';
import { backendSearch, SearchModule } from '@shared/datastore/core';
import { searchKeywordProjectsBackend } from './search-keyword-projects.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { transformSearchKeywordProjects } from './search-keyword-projects.transformers';

backendSearch.searchKeywordProjects = searchKeywordProjectsBackend;

@NgModule({
  imports: [
    SearchModule.forFeature(
      'searchKeywordProjects',
      transformSearchKeywordProjects,
    ),
    /* DatastoreBackendModule.forFeature(
      'searchKeywordProjects',
      searchKeywordProjectsTransformer,
    ),*/
  ],
})
export class DatastoreSearchKeywordProjectsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/search-keyword-projects/search-keyword-projects.module.ts